var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54236 13.4576C1.54236 6.03705 7.57948 0 15 0C22.4205 0 28.4576 6.03705 28.4576 13.4576H1.54236Z",
    fill: "#E7886E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1533 17.2655C27.8927 17.2655 29.3027 15.8555 29.3027 14.1161C29.3027 12.3768 27.8927 10.9668 26.1533 10.9668C24.414 10.9668 23.004 12.3768 23.004 14.1161C23.004 15.8555 24.414 17.2655 26.1533 17.2655Z",
    fill: "#FED2A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8651 31.9991H10.135L7.0921 28.6034C8.11456 25.1896 10.4106 23.625 10.4106 23.625H19.5895C19.5895 23.625 21.8855 25.1896 22.908 28.6034L19.8651 31.9991Z",
    fill: "#5C586F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8769 13.0299C5.8769 6.68974 10.0313 1.38134 15.6036 0.0142294C15.4034 0.00534406 15.2024 0 15.0001 0C7.57953 0 1.54248 6.03705 1.54248 13.4576H5.88399C5.87974 13.3155 5.8769 13.1731 5.8769 13.0299Z",
    fill: "#E7886E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0783 7.58923C22.0704 8.13536 20.8549 8.13536 19.847 7.58923C18.8391 7.04317 17.6236 7.04317 16.6157 7.58923C15.6078 8.13529 14.3923 8.13529 13.3844 7.58923C12.3765 7.04317 11.161 7.04317 10.1531 7.58923C9.14524 8.13529 7.92976 8.13529 6.92186 7.58923C6.55498 7.39047 6.16049 7.26498 5.75859 7.2109C4.55186 8.99292 3.84689 11.1425 3.84689 13.4566C3.84689 19.6163 8.84031 24.6098 15.0001 24.6098C21.1599 24.6098 26.1533 19.6164 26.1533 13.4566C26.1533 11.1424 25.4483 8.99292 24.2416 7.2109C23.8397 7.26498 23.4452 7.39047 23.0783 7.58923Z",
    fill: "#FED2A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1351 28.6035V31.9993H6.61063C6.61063 30.7109 6.79928 29.5815 7.09224 28.6035H10.1351Z",
    fill: "#FED2A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3897 31.9993H19.8651V28.6035H22.908C23.201 29.5815 23.3897 30.7109 23.3897 31.9993Z",
    fill: "#FED2A4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1978 23.9446C7.97898 21.5259 5.8769 17.5386 5.8769 13.0289C5.8769 11.0982 6.26277 9.26357 6.95602 7.6064C6.94475 7.60041 6.93309 7.59532 6.92189 7.58927C6.55502 7.39051 6.16052 7.26502 5.75862 7.21094C4.99584 8.33738 4.43394 9.61068 4.1234 10.9795C4.0359 10.9709 3.94435 10.9658 3.84693 10.9658C2.1076 10.9658 0.697601 12.3758 0.697601 14.1151C0.697601 15.8545 2.1076 17.2645 3.84693 17.2645C4.09037 17.2645 4.30117 17.2359 4.48538 17.1837C5.59708 20.3198 8.07189 22.811 11.1978 23.9446Z",
    fill: "#FED2A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f6521010e4ed33df0831b6087e6d4067.svg";
export { ForwardRef as ReactComponent };